import React, { Component } from 'react';
import { translate } from 'react-polyglot';
import classNames from 'classnames';
import SvgIcon from '../SvgIcon';

import './PortraitViewMessage.scss';

@translate()
class PortraitViewMessage extends Component {
  static defaultProps = {
    background: 'default'
  }


  render() {
    const {t, isRtl} = this.props;
    const baseClassName = 'pb-portrait-view-message';
    const classes = {
      [baseClassName]: true,
      [`${baseClassName}__rtl`]: isRtl,
    }

    return (
      <div className={classNames(classes)}>  
        <div className={`${baseClassName}__message-content`}>   
          <div className={`${baseClassName}__heading`}>
              {t('global.portrait-head')}
          </div>
          <div className={`${baseClassName}__message-body`}>
              <div className={`${baseClassName}__message-icon`}>
                  <SvgIcon name="portrait" size="l" />
              </div>
              <div className={isRtl ? `${baseClassName}__message ${baseClassName}__message--rtl` : `${baseClassName}__message`}>
                {t('global.portrait-view-message')}
              </div>
              
          </div>
        </div>
    </div>
    );
  }
}

export default PortraitViewMessage;



// WEBPACK FOOTER //
// ./src/components/PortraitViewMessage/PortraitViewMessage.jsx